import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'styled-bootstrap-grid';
import { InfiniteQueryObserverResult } from 'react-query';
import useTranslation from 'next-translate/useTranslation';
import { Raffle } from '../../../api';
import { ResponseWrapperPaginated } from '../../../api/lib/api/ResponseWrapper';

import RaffleCard from '../../Contest/Card';
import { GradientButton } from '../../common/Buttons';
import { CenteredLoader } from '../../common/Loader';

const RafflesGrid = ({
  useFetch,
}: {
  useFetch: () => Omit<
    InfiniteQueryObserverResult<ResponseWrapperPaginated<Raffle[]>>,
    'data'
  > & { data: Raffle[] };
}) => {
  const { t } = useTranslation('profile');
  const { isLoading, data, fetchNextPage, hasNextPage } = useFetch();
  return (
    <Container>
      <Row>
        {data.map((raffle) => (
          <ColWithMargin md={6} key={raffle.id}>
            <RaffleCard raffle={raffle} />
          </ColWithMargin>
        ))}
      </Row>
      {hasNextPage && isLoading && <CenteredLoader />}
      {hasNextPage && !isLoading && (
        <CenteredRow>
          <GradientButton onClick={() => fetchNextPage}>
            {t('profile:loadMore')}
          </GradientButton>
        </CenteredRow>
      )}
    </Container>
  );
};

export default RafflesGrid;

const ColWithMargin = styled(Col)`
  margin-bottom: 15px;
`;

const CenteredRow = styled(Row)`
  display: flex;
  justify-content: center;
`;
